module.exports = __webpack_public_path__ + "static/sprite-a3541a4a0d9f62eaee7d3d8359c34c64.svg";